import axios from "axios";

import { axiosRefreshTokenSetup } from "@fixit/utils";
import Vue from "vue";

axiosRefreshTokenSetup(axios);

Vue.prototype.$axios = axios;
